<template>
  <div class="intro_contents">
    <div class="bg" :class="{ policy_footer: hasPolicyFooter }">
      <div class="wrapper_img" :class="{ policy_footer: hasPolicyFooter }">
        <div class="gradient_left" />
        <div class="gradient_top" />
        <h3>{{ $t('intro.title') }}</h3>
        <p v-html="$t('intro.desc')" />
      </div>
    </div>
    <div v-if="isLogin" class="content inner wrapper_point">
      <h3>{{ $t('intro.title_list') }}</h3>
      <ul v-if="pointList.length">
        <li
          v-for="(point, index) of pointList"
          :key="index"
          @click="goToServicePage(point, `/${point.pathKey}/pointHistory`)"
        >
          <img :src="point.listImageUrl" alt="" />
          <span class="text_point_name">{{ point.pointName }}</span>
          <span class="text_desc">{{ point.description }}</span>
        </li>
      </ul>
      <div v-if="isLoaded && pointList.length === 0">{{ $t('intro.default_text') }}</div>
    </div>
    <div class="wrapper_content" :class="{ policy_footer: hasPolicyFooter }" v-else>
      <div class="wrapper_guide">
        <h2 class="text_content_guide">{{ $t('intro.initial_text') }}</h2>
        <button class="btn_login" @click="changeAccountState">{{ $t('gnb.login') }}</button>
      </div>
      <div class="main_img" />
    </div>
  </div>
</template>

<script>
import sendLog from '@/utils/analistic';
import { mapGetters } from 'vuex';
import { checkUserRegion, goToLoginPage, isLogin, loginModal, logout } from '@/utils';
import { getNeededLanguage } from '@/utils/lang';

export default {
  name: 'Intro',
  props: {
    isLoaded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['pointList']),
    isLogin() {
      return isLogin();
    },
    userRegion() {
      return checkUserRegion();
    },
    hasPolicyFooter() {
      return this.userRegion === 'krpc' || this.userRegion === 'jppc';
    },
  },
  created() {
    sendLog('intro', {}, 'contents');
  },
  methods: {
    goToServicePage(point, path) {
      if (!point.pathKey) return;
      if (!isLogin()) {
        return loginModal(path);
      } else {
        this.$router.push({
          path: `/${getNeededLanguage()}/${point.pathKey}/pointHistory`,
          query: { ...this.$route.query },
        });
      }
    },
    changeAccountState() {
      !this.isLogin ? goToLoginPage() : logout();
    },
  },
};
</script>

<style lang="scss" scoped>
.intro_contents {
  font-family: NEXONLv1Gothic;
  min-height: inherit;
  background: #fff;
}
.bg {
  display: flex;
  justify-content: center;
  height: 360px;
  background-color: #121637;
  &.policy_footer {
    height: 332px;
  }
}
.wrapper_img {
  background: url('~@/assets/images/img_intro.svg') no-repeat center / cover;
  width: 1382px;
  height: 360px;
  position: relative;
  h3 {
    position: absolute;
    top: 80px;
    left: 15.26%;
    margin-bottom: 22px;
    font-weight: 700;
    font-size: 20px;
    line-height: 30px;
    letter-spacing: -0.43px;
    color: #ffeb00;
    font-family: 'Noto Sans KR', sans-serif;
  }
  p {
    position: absolute;
    top: 132px;
    left: 15.26%;
    font-weight: 700;
    font-size: 36px;
    line-height: 54px;
    letter-spacing: -0.5px;
    color: #ffffff;
    font-family: 'Noto Sans KR', sans-serif;
  }
  &.policy_footer {
    height: 332px;
  }
}

.wrapper_point {
  margin: 50px auto;
  padding: 0 30px;
  h3 {
    font-size: 20px;
    font-weight: 700;
    line-height: 1.25;
    color: #333;
    margin-bottom: 28px;
  }
  ul {
    display: flex;
    column-gap: 60px;
    row-gap: 50px;
    flex-wrap: wrap;
  }
  li {
    display: flex;
    flex-direction: column;
    width: 280px;
    cursor: pointer;
  }
  img {
    height: 60px;
  }
  .text_point_name {
    margin-top: 15px;
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    color: #333;
  }
  .text_desc {
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 14px;
    color: #999;
    font-family: 'Noto Sans JP', 'Malgun Gothic', Arial, sans-serif;
  }
}

.wrapper_content {
  width: 100%;
  height: calc(100vh - 523px);
  min-height: 320px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 54px;
  padding-bottom: 75.56px;
  background: #eef1f6;
  &.policy_footer {
    min-height: calc(100vh - 522px);
  }
}

.main_img {
  background: url('~@/assets/images/img_main.svg') no-repeat center / 100% 100%;
  width: 100%;
  height: 358px;
  position: relative;
}

.text_content_guide {
  font-family: 'Noto Sans KR', sans-serif;
  color: #17191c;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: -0.4px;
}

.wrapper_guide {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 24px;
}

.btn_login {
  display: flex;
  width: 108px;
  height: 36px;
  padding: 10px 14px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 50px;
  border: 1px solid #17191c;
  color: #17191c;
  background-color: #eef1f6;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.3px;
  &:hover {
    background-color: #e8ebf2;
  }
}

@media (hover: none) {
  .btn_login:hover {
    color: #17191c;
  }
}

@media all and (max-width: 1280px) {
  .wrapper_img {
    h3,
    p {
      left: 15%;
    }
  }
}

@media all and (max-width: 767px) {
  .wrapper_img {
    background: url('~@/assets/images/img_intro.svg') no-repeat 48% 50% / cover;
    h3,
    p {
      left: 30px;
    }
    h3 {
      font-size: 20px;
      line-height: 30px;
      letter-spacing: -0.43px;
    }
    p {
      font-size: 32px;
      line-height: 48px;
      letter-spacing: -0.45px;
    }
  }
  .wrapper_content {
    height: calc(100vh - 524px);
    padding-top: 54px;
    padding-bottom: 110px;
  }
}

@media all and (max-width: 480px) {
  .gradient_left {
    width: 360px;
    height: 200px;
    position: absolute;
    top: 52px;
    left: -84px;
    transform: rotate(-90deg);
    flex-shrink: 0;
    background: linear-gradient(180deg, #0a1455 22.16%, rgba(16, 27, 92, 0) 100%);
  }
  .gradient_top {
    position: absolute;
    top: 0;
    width: 100%;
    height: 192px;
    background: linear-gradient(159deg, #0a1552 23.4%, rgba(16, 27, 92, 0) 85.43%);
  }
  .wrapper_img {
    background: url('~@/assets/images/img_intro@480.svg') right bottom / cover no-repeat;
    h3 {
      left: 10px;
      top: 40px;
      font-size: 18px;
      line-height: 28px;
      letter-spacing: -0.4px;
    }
    p {
      left: 10px;
      top: 83px;
      font-size: 26px;
      line-height: 42px;
      letter-spacing: -0.43px;
    }
  }
  .wrapper_content {
    height: calc(100vh - 524px);
    padding-top: 48px;
    padding-bottom: 45px;
  }

  .main_img {
    background: url('~@/assets/images/img_main@480.svg') no-repeat center / 100% 100%;
    height: 245px;
  }

  .text_content_guide {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.35px;
  }

  .btn_login {
    height: 32px;
  }
}

@media all and (max-width: 360px) {
  .wrapper_content {
    height: calc(100vh - 523px);
    padding-top: 36px;
    padding-bottom: 28px;
  }

  .main_img {
    background: url('~@/assets/images/img_main@360.svg') no-repeat center / 100% 100%;
    height: 168px;
  }

  .text_content_guide {
    font-size: 14px;
    line-height: 22px;
    letter-spacing: -0.3px;
  }

  .wrapper_guide {
    margin-bottom: 25px;
    gap: 8px;
  }
  .btn_login {
    width: 72px;
    height: 32px;
  }
}

@media all and (max-width: 320px) {
  .wrapper_point {
    padding: 0 15px;
  }
  .gradient_left {
    width: 157px;
    height: 360px;
    position: absolute;
    top: -35px;
    left: 0;
    transform: rotate(0deg);
    background: linear-gradient(180deg, #0c154a 0%, rgba(10, 20, 85, 0) 55%);
  }
  .gradient_top {
    height: 185px;
    flex-shrink: 0;
    top: -35px;
    background: linear-gradient(180deg, #0c154a 0%, rgba(10, 20, 85, 0) 100%);
  }
  .wrapper_img {
    background: url('~@/assets/images/img_intro@320.svg') no-repeat right bottom / contain;
    width: 312px;
    height: 325px;
    position: absolute;
    top: 105px;
    h3,
    p {
      left: 15px;
    }
    h3 {
      top: -6px;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: -0.35px;
    }
    p {
      top: 30px;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: -0.43px;
    }
  }
}
</style>
